import { useQuery } from "@tanstack/react-query";
import axios from "../axios";

const useGetSellerBy_id = ({
  _id = "",
  fields = ["_id"]
}) => {
  const query = useQuery({
    queryKey: ["seller-2", _id, fields],
    queryFn: async () => {
      try {
        const fieldsString = JSON.stringify(fields);
        const urlEncodedFields = encodeURIComponent(fieldsString);
        return await axios.get("/api/sellerprofile/single", {
          params: {
            _id,
            fields: urlEncodedFields,
          },
        });
      } catch (error) {
        console.log(error);
      }
    },
    staleTime: 30000,
  });

  return query;
};

export default useGetSellerBy_id;
